import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/auth";
import { Toast } from 'primereact/toast';
import { useFormik } from "formik";
import Loading from "../components/Loading";

export default function Login() {
    const auth = useAuth();
    const history = useNavigate();
    const toast = useRef();

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validate: (data) => {
            let errors = {};

            if (!data.email) {
                errors.email = 'O campo e-mail é obrigatório.';
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
                errors.email = 'Digite um endereço de e-mail válido. Exemplo example@gmail.com'
            }

            if (!data.password) {
                errors.password = 'O campo senha é obrigatório.'
            } else if (data.password.length < 8) {
                errors.password = 'O campo senha precisa de no minímo 8 caracteres.'
            }

            return errors;
        },
        onSubmit: (data) => {
            handleLogin(data);
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    function handleLogin(formData) {
        auth.Login({
            email: formData.email,
            password: formData.password
        }).then((response) => {
            if(response.status === 200) {
                localStorage.setItem('@App:token', response.data.token);

                auth.setUser(response.data.user);
                auth.setSigned(true);
                auth.setLoading(false);
                history('/');
            }
        }).catch((error) => {
            auth.setSigned(false);
            auth.setLoading(false);
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: error.response ? error.response.data.message : 'Credenciais inválidas.'
            });
        });
    }

    if(auth.loading) {
        return <Loading />
    }

    if(!auth.loading && auth.signed){
        return <Navigate to="/" />
    }

    return (
        <div>
            <Toast ref={toast} />
            <div className="card">
                <div className="p-grid p-d-flex p-flex-column p-jc-center p-ai-center" style={{ height: 'calc(100vh - 16px)', width: '100%' }}>
                    {/* <img alt="logo" draggable="false" style={{ margin: 16 }} src={logo} /> */}
                    <Card title="Login" style={{ minWidth: '40vw' }}>
                        <form onSubmit={formik.handleSubmit} className="p-d-flex p-flex-column p-jc-center p-ai-center p-fluid p-col-12">
                            <div className="p-field p-col-12">
                                <InputText
                                    id="email"
                                    type="email"
                                    onChange={formik.handleChange}
                                    placeholder="Digite o e-mail"
                                    value={formik.values.email}
                                />
                                {getFormErrorMessage('email')}
                            </div>
                            <div className="p-field p-col-12">
                                <InputText
                                    id="password"
                                    onChange={formik.handleChange} 
                                    placeholder="Digite a senha"
                                    type="password"
                                    value={formik.values.password}
                                />
                                {getFormErrorMessage('password')}
                            </div>
                            <Button type="submit" label="Entrar" />
                        </form>
                    </Card>
                </div>
            </div>
        </div>
    )
}